import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-book-settings-outline',
  templateUrl: './icon-book-settings-outline.component.html',
  styleUrl: './icon-book-settings-outline.component.scss',
  standalone: false,
})
export class IconBookSettingsOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
